// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1ZJG4","requiredAsterisk":"Info_requiredAsterisk__7LJAH"};